/* tslint:disable:max-line-length */
import { Messages } from '../messages.interfaces';

// [es] Spanish - Español
export const es: Messages = {
  close: {
    buttonText: 'Cerrar',
    description: 'Cerrar búsqueda'
  },
  columnsPicker: {
    name: 'Selector de columnas',
    title: 'Ver'
  },
  discoveryWall: {
    clicks: 'Tus últimas búsquedas',
    queries: 'Nuevos productos relacionados con tus búsquedas',
    section: 'Búsquedas populares en {section}',
    user: 'Muy de tu estilo'
  },
  facets: {
    clearFilters: 'Limpiar filtros',
    defaultDynamicRange: {
      clear: '×',
      filter: '→'
    },
    defaultRange: { lessHTML: '< {max}', betweenHTML: '{min} - {max}', fromHTML: '> {min}' },
    itemCounter: '{value} resultados',
    searchBoxPlaceholder: 'Buscar {title}',
    showLess: 'Mostrar menos',
    showMore: 'Mostrar más',
    titles: {
      rootCategories: 'Categorías',
      hierarchical_category: 'Categorías',
      color_facet: 'Color',
      size_facet: 'Talla'
    },
    toggle: {
      default: {
        closeHTML: 'Aplicar filtros',
        openHTML: 'Filtrar'
      },
      groups: {}
    },
    values: {}
  },
  fallbackFilters: {
    messageHTML: `<span class="ebx-fallback-facet__message-apologies">¡Lo sentimos! No hemos podido encontrar resultados para la búsqueda
<strong class="ebx-fallback-facet__message-query">{query}</strong> en
<strong class="ebx-fallback-facet__message-filter">{filter}</strong></span><span class="ebx-fallback-facet__message-try-again">,
pero hemos encontrado estas otras combinaciones de filtros con resultados:</span>`
  },
  history: {
    title: 'Búsquedas recientes',
    enable: 'Activar',
    disable: 'Desactivar',
    clear: 'Borrar todo',
    clearItem: 'Borrar elemento del historial {term}'
  },
  identifierSuggestions: {
    title: ''
  },
  nextQueriesSuggestions: {
    title: 'Te puede interesar'
  },
  nextQueries: {
    titleHTML: '',
    nextQuery: {
      titleHTML: 'Otros clientes han buscado: <span class="ebx-next-query__title-query">{query}</span> <span class="ebx-next-query__title-count">({numFound})</span>',
      viewAllHTML: 'Ver todos <span class="ebx-next-query__view-all-count">({numFound})</span>'
    }
  },
  noResults: {
    messageHTML: `<span class="ebx-no-results__message-apologies">Lo sentimos, no hemos podido encontrar resultados para la búsqueda: </span>
<span class="ebx-no-results__message-query">{query}</span>
<span class="ebx-no-results__message-try-again">. Por favor, prueba de nuevo con otras palabras.</span>`
  },
  emptySearch: {
    message: ''
  },
  partialResult: {
    titleHTML: '<span class="ebx-partial-result__title-term">{term}</span> <span class="ebx-partial-result__title-num-found">({numFound})</span>',
    messageHTML: `<span class="ebx-partials__message-apologies">¡Lo sentimos! No hemos podido encontrar resultados para tu búsqueda: </span><span class="ebx-partials__message-query">{query}</span><span class="ebx-partials__message-try-again">, pero hemos encontrado estos otros:</span>`,
    viewAllHTML: 'Ver todos <span class="ebx-partial-result__view-all-count">({numFound})</span>'
  },
  promotedLabel: '',
  redirectionsSuggestions: {
    title: 'Enlaces directos'
  },
  resultsFoundHTML: '<span class="ebx-results-number__count">{resultsNumber}</span> resultados',
  search: {
    clear: 'Limpiar búsqueda',
    name: 'Caja de búsqueda',
    suggestion: 'Sugerencia de búsqueda {suggestion}',
    inputPlaceholderAlternativesHTML: ['Buscar']
  },
  popularSearches: {
    title: 'Búsquedas populares',
    inCategory: 'en'
  },
  rating: {
    ariaLabel: 'Puntuado con un {value} sobre {max}',
    label: '{value}'
  },
  recommendations: {
    title: 'Quizás estés interesado',
    showAll: 'Ver todos'
  },
  results: {
    addToCart: 'Añadir al carrito',
    identifierTitle: '',
    addToWishlist: 'Añadir a deseados',
    removeFromWishlist: 'Quitar de deseados'
  },
  resultsSuggestions: { title: 'Productos más buscados' },
  sections: {},
  selectedFilters: {
    title: 'Filtros seleccionados ({count})'
  },
  slidingPanel: {
    scrollLeft: 'Desplazarse a la izquierda',
    scrollRight: 'Desplazarse a la derecha'
  },
  sort: {
    titleHTML: 'Ordenar por {selectedItem}',
    sortTitles: {
      default: 'Relevancia',
      priceAsc: 'Precio asc',
      priceDesc: 'Precio desc'
    }
  },
  spellcheck: 'No hemos encontrado resultados para \'{query}\'. Te mostramos resultados para \'{spellcheck}\'',
  suggestions: {
    title: 'Lo más buscado',
    inCategory: 'en'
  },
  scrollToTop: {
    name: 'Volver al comienzo'
  }
};
